<template>
    <div>
        <wrapper-edit
                :wrapper-width="wrapperWidth"
                @back="paasPageBack">
            <Form ref="paasForm" slot="form"
                  :model="paasFormData"
                  :rules="paasFormRules"
                  :label-width="defaultLabelWidth">
                <Row>
                    <FormItem label="任务名称：" prop="jobName" class="ivu-col-span-24" >
                        <Input v-model="paasFormData.jobName"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="任务分组：" prop="jobGroup" class="ivu-col-span-24" >
                        <Input v-model="paasFormData.jobGroup"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="任务描述：" prop="description" class="ivu-col-span-24" >
                        <Input v-model="paasFormData.description"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="执行类：" prop="jobClassName" class="ivu-col-span-24" >
                        <Input v-model="paasFormData.jobClassName"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="执行时间：" prop="cronExpression" class="ivu-col-span-24" >
                        <Input v-model="paasFormData.cronExpression"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <div class="edit-oper-toolbar">
                    <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
                    <Button @click="paasFormSubmit('paasForm','','quartzEntityList')" style="margin-left: 8px">保存并返回</Button>
                    <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
                </div>
            </Form>

        </wrapper-edit>
    </div>
</template>
<script>
    import wrapperEdit from "@/components/paas/wrapper-edit";
    import metaEdit from "@/assets/js/meta-edit.js";

    export default {
        name: "edit",
        mixins:[metaEdit],
        components:{wrapperEdit},
        data(){
            return {
                serviceUrl:"/quartz/entity",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                paasFormData:{
                    id:'',
                    jobName:'',
                    jobGroup:'',
                    description:'',
                    jobClassName:'',
                    cronExpression:'',
                    triggerName:'',
                    triggerState:'NORMAL',
                    oldJobName:'',
                    oldJobGroup:'',
                },
                paasFormRules:{
                    jobName:[
                        {
                            message: '任务名称必须填写',
                            trigger: 'blur',
                            required: true,
                        },
                    ],
                    cronExpression:[
                        {
                            message: '执行时间必须填写',
                            trigger: 'blur',
                            required: true,
                        },
                    ],
                    description:[
                        {
                            message: '任务描述必须填写',
                            trigger: 'blur',
                            required: true,
                        },
                    ],
                    jobGroup:[
                        {
                            message: '任务分组必须填写',
                            trigger: 'blur',
                            required: true,
                        },
                    ],
                    jobClassName:[
                        {
                            message: '执行类必须填写',
                            trigger: 'blur',
                            required: true,
                        },
                    ]
                },
                redirectName:"quartzEntityList",
                nextAddName:"quartzEntityEdit",
            }
        },
        methods:{
            createdCallback(data) {
                ;
                //this.paasFormData.oldJobName = data.entity.jobName;
                //this.paasFormData.oldJobGroup = data.entity.jobGroup;
            },
        }
    }
</script>
